import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';

declare const Pusher:any;

@Injectable({
    providedIn: 'root'
})

export class CallingScreenService {
    token = localStorage.getItem('token');
    pusher: any;
    channel: any;
    delegationChannel: any;
    isUnavalibeFlag: boolean = false;
    private _getBackData = new BehaviorSubject<boolean>(false);
    getBackData = this._getBackData.asObservable();
    private channels: { [key: string]: any } = {};

    constructor(private http: HttpClient,
    ) {
        this.pusher = new Pusher(environment.PUSHER_API_KEY, {
            cluster: environment.PUSHER_API_CLUSTER,
            encrypted: true
        });

        // this.channel = this.pusher.subscribe(`calling_screen_${localStorage.getItem('schoolId')}`);
        // to check the current state of the connection and reload the page if the current state is connected and the previous is unavailable to get the calling screen data 
        // this.pusher.connection.bind("state_change", (states) => {
        //     if (states.previous == 'connecting' && states.current == 'unavailable') {
        //         this.isUnavalibeFlag = true;
        //     }
        //     if (states.current == 'connected' && this.isUnavalibeFlag == true) {
        //         this.setIsReconected(true);
        //     }
        // });
        // this.delegationChannel = this.pusher.subscribe(`delegation_request_user_${localStorage.getItem('userId')}`);
    }

    showCallingScreen(schoolId) {
        return this.http.get(environment.url + `schools/${schoolId}/requests/calling_screen/${localStorage.getItem('userId')}`).pipe(timeout(10000), catchError(
            (err: any, caught: Observable<HttpEvent<any>>) => {
                throw err;
            }
        ));
    }

    getTeacherClasses(teacherId , lastSelectedSchoolId) {
        return this.http.get(environment.url + `teachers/${teacherId}/classes?school_id=${lastSelectedSchoolId}`);
    }

    getClassAttendance(classId) {
        return this.http.get(environment.url + `classes/${classId}/attendance`);
    }

    getSupervisorGrades(supervisorId , lastSelectedSchoolId) {
        return this.http.get(environment.url + `supervisors/${supervisorId}/grades?school_id=${lastSelectedSchoolId}`);
    }
    getRequestById(requestId, role_type) {
        return this.http.get(environment.url + `requests/${requestId}/calling-screen?role_type=${role_type}`);
    }

    teacherDeliver(students) {
        return this.http.put(environment.url + `v2/requests/schools/${localStorage.getItem('schoolId')}/teacher/deliver`, students);
    }
    supervisorDeliver(students) {
        return this.http.put(environment.url + `v2/requests/schools/${localStorage.getItem('schoolId')}/supervisor/deliver`, students);
    }


    setIsReconected(bool) {
        this.isUnavalibeFlag = bool
        this._getBackData.next(bool);

    }
    getIsReconected() {
        return this._getBackData;
    }

    subscribe(channelName: string, eventName: string, callback: (data: any) => void) {
        if (!this.pusher) return;

        let channel = this.pusher.subscribe(channelName);
        channel.bind(eventName, callback);

        this.channels[channelName] = channel; // Track the channel
        console.log('csChannels', this.channels);
    }

    unsubscribe(channelName: string) {
        if (!this.pusher || !this.channels[channelName]) return;

        this.pusher.unsubscribe(channelName);
        delete this.channels[channelName]; // Clean up channel tracking
        console.log('csChannelsAfterUnsub', this.channels);
    }

    cleanup(): void {
        console.log('callingScreenServiceDestroyed');
        // Unsubscribe from all channels
        for (let channelName in this.channels) {
            this.unsubscribe(channelName);
        }
    }
}